import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
interface TimelineSectionHeaderPeriodBlockProps {
  yearFrom: number;
  yearTo: number;
  handleToggle: () => void;
  isExpanded: boolean;
  align?: "left" | "right";
  entriesCount?: number;
  onCreateMemory?: () => void;
}
const TimelineSectionHeaderPeriodBlock = ({
  yearFrom,
  yearTo,
  handleToggle,
  isExpanded,
  align = "right",
  entriesCount = 0,
  onCreateMemory
}: TimelineSectionHeaderPeriodBlockProps) => {
  const {
    t
  } = useTranslation('common');
  const hasEntries = entriesCount > 0;
  const handleButtonClick = () => {
    if (!hasEntries && onCreateMemory) {
      onCreateMemory();
    } else {
      handleToggle();
    }
  };
  return <div className={cn("period-block w-full", align === "left" ? "flex flex-col items-end pr-8" : "flex flex-col items-start pl-8")}>
      <div className="timeline-marker relative mb-3"></div>
      <div className="text-4xl font-normal text-uplivion-blue">
        {yearFrom}
      </div>
      <div className="text-2xl font-black text-uplivion-blue">
        {t('timeline.to', 'bis')} {yearTo}
      </div>
      
      <div className="flex items-center gap-2 mt-4">
        <button type="button" onClick={handleButtonClick} className={cn("inline-flex items-center font-medium rounded-full text-xs px-[8px] py-[4px] transition-colors", hasEntries ? "text-white bg-uplivion-orange hover:bg-opacity-90" : "text-gray-500 bg-black bg-opacity-20 hover:bg-opacity-30")}>
          {isExpanded ? t('timeline.closeEvents', 'Ereignisse schließen') : hasEntries ? `${entriesCount} ${t('timeline.showEvents', 'Ereignisse anzeigen')}` : t('timeline.createFirstMemory', 'Erste Erinnerung hinzufügen')}
        </button>
        
        <button type="button" onClick={onCreateMemory} className="inline-flex items-center justify-center font-medium rounded-full text-xs px-[8px] py-[4px] transition-colors text-white bg-uplivion-orange hover:bg-opacity-90">
          <Plus className="h-3 w-3" />
        </button>
      </div>
    </div>;
};
export default TimelineSectionHeaderPeriodBlock;